import Vue from 'vue'

export const obserState = Vue.observable({
    current: 'playTypeList',
    playTypeList: [
        { label: Vue.prototype.$t("code-lab/component/robot-connect/play-button/microstate/checkBox.js_0"), tag: 0, checked: true, disabled: false  },
        { label: Vue.prototype.$t("code-lab/component/robot-connect/play-button/microstate/checkBox.js_1"), tag: 1, checked: false, disabled: true },
    ],
    noGetKey: [
        { label: Vue.prototype.$t("code-lab/component/robot-connect/play-button/microstate/checkBox.js_1"), tag: 1, checked: false, disabled: true },
    ]
})

export function hdCurrent (payload) {
    console.log(payload, 'hdCurrent')
    obserState.current = payload
}


export function reset (payload) {
    const { key, val } = payload
    obserState[obserState.current].forEach(ff => ff[key] = val)
    console.log(payload)
}

export function update (payload) {
    const { index, val, key, tag } = payload
    const trgt = typeof tag === 'number' ? obserState[obserState.current].find(fd => fd['tag'] === tag) : obserState[obserState.current][index]
    console.log(trgt, tag)
    trgt[key] = val
}


export const obserMutations = {
    update, reset, hdCurrent
}
